import { Question } from "../../types/questionTypes"
import OnboardingOverview from "../OnboardingOverview"
import SurveyComponent from "../SurveyComponent"
import "./index.scss"
import { SurveyContextProvider } from "./SurveyContext"
import { Provider } from "@rollbar/react"
import { getRollbarConfig } from "../../util/rollbarConfig"
import { ExplainersType, SurveyOverviewTexts } from "~/types/dataTypes"
import { useState } from "react"
import { toCamelCase } from "~/util/toCamelCase"

interface MainComponentProps {
  surveys: Record<string, Array<Question>>
  allSurveys: Array<string>
  projectPrefix: string
  surveyEstimates: Record<
    string,
    { name: string; estimatedTimeToComplete: number }
  >
  explainers: ExplainersType
  surveyOverviewTexts: SurveyOverviewTexts
}

export default function Main({
  surveys,
  allSurveys,
  projectPrefix,
  surveyEstimates,
  explainers,
  surveyOverviewTexts
}: MainComponentProps): JSX.Element {
  const [currentPage, setCurrentPage] = useState<string>("overview") // Can be "overview" or a survey name (id)
  const currentSurvey = surveys[toCamelCase(currentPage)]

  return (
    <Provider config={getRollbarConfig()}>
      <SurveyContextProvider
        surveys={Object.keys(surveys)}
        allSurveys={allSurveys}
      >
        <div className="main">
          {currentPage === "overview" ? (
            <OnboardingOverview
              surveyEstimates={surveyEstimates}
              onOpenSurvey={setCurrentPage}
              texts={surveyOverviewTexts}
            />
          ) : (
            <SurveyComponent
              projectPrefix={projectPrefix}
              explainers={explainers}
              surveyEstimates={surveyEstimates}
              name={currentPage}
              onSurveySubmit={() => setCurrentPage("overview")}
              surveyMetadata={currentSurvey}
            />
          )}
        </div>
      </SurveyContextProvider>
    </Provider>
  )
}
